// @flow
import React, {useContext, useEffect, useState} from 'react';
import {Redirect} from 'react-router';

import ArchiverClientApi from "../API/archiverClientApi";
import {useCookies} from "react-cookie";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";

// import logoImage from '../GUI_COMMON/IMAGES/microscope-trans-gray2-192.png'
import logoImage from '../GUI_COMMON/IMAGES/keepTrackLogo-240609.png'
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import {setClientInfo} from "../GUI_COMMON/ACTIONS/commonClientActions";
import LoginFormWithKeyboard from "../GUI_COMMON/COMPONENTS/LoginFormWithKeyboard";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import {checkAndReportWwwAppUpdate} from "../GUI_COMMON/SUPPORT/update";
import LoadingOverlay from "../GUI_COMMON/COMPONENTS/LoadingOverlay";

const LoginPage = () => {

    const [cookies, setCookies,] = useCookies();
    const [, dispatch] = useContext(StoreContext);
    const [redirectToDashboard, setRedirectToDashboard] = useState();
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        
        console.debug("loginPage(): starting up...");
        if(LIUtils.isAuthenticatedHook(cookies)) {
            setRedirectToDashboard(true);
        }
        checkAndReportWwwAppUpdate(false);
    }, []);   // eslint-disable-line react-hooks/exhaustive-deps
 
    function onSubmit(authCode) {
        const form = document.getElementById("loginForm");
        if (form.checkValidity() === false) {
            return;
        }

        // STEP 1 - login to the WebService 
        setIsLoading(true);
        ArchiverClientApi.sendSignInRequest(authCode)
        .then((authInfo) => {
            if (authInfo.isAuthenticated === false) {
                ErrorPopup.showError("SignIn Problem", "Not authenticated");
                setIsLoading(false);
                return;
            }

            try {
                LIUtils.saveAuthInfoToCookieHook(authInfo,setCookies);
                dispatch(setClientInfo(authInfo.userId, authInfo.fullName, authInfo.level));
                setRedirectToDashboard(true);
                // we are out of here, so no need to change isLoading
            } catch (ex) {
                throw ex;      // rethrow
            }
        })
        .catch(responseError => {
            ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError);
            setIsLoading(false);

        });
    }
    
    if(redirectToDashboard) {
        return <Redirect to="/dashboard"/>;
    }
    
    return (<div className="container">
        <title>KeepTrack Sign-in</title>
        <div className="mt-5" style={{backgroundImage: `url(${logoImage})`, backgroundSize:"cover", backgroundPosition:"center",
                                backgroundRepeat:"no-repeat", backgroundBlendMode:"lighten", backgroundColor:"rgba(255,255,255,0.90)"}}>
            <div className="li-centered-all">
                <div className="li-bg-card li-card li-login-card">
                    <div className="mb-1 text-center li-page-header-bg li-bg-login-header">
                        <img className="mb-1 mt-0 mr-2" src={logoImage} width="80px" alt="logo"/>
                        <span className="li-font-medium align-top position-absolute mb-1 font-italic">&nbsp;KeepTrack</span>
                        <span className="li-font-huge align-middle font-weight-bold">Archiver</span>
                    </div>
                    <LoginFormWithKeyboard onSubmit={onSubmit} isBusy={isLoading} isPassword/>
                </div>
            </div>
        </div>
        <LoadingOverlay show={isLoading} message={"Logging in..."} />
    </div>);
}

LoginPage.propTypes = {};

export default LoginPage;